import { recommendationsDataAtom } from "@sunrise/yallo-recommendations";
import { atom } from "jotai";
import { isNil } from "lodash";

/**
 * Creates a function to easily know what item is at a given position in the recommendations "grid".
 * This is async but the function returned is sync. So we can easily use it in the navigation callbacks.
 */
export const itemAtRecommendationCoordinatesAtom = atom(async (get) => {
  const data = await get(recommendationsDataAtom);

  return (reference: { rowIndex: number; colIndex: number }) => {
    if (isNil(data)) {
      return null;
    }

    return data[reference.rowIndex]?.items[reference.colIndex] ?? null;
  };
});

itemAtRecommendationCoordinatesAtom.debugLabel =
  "itemAtRecommendationCoordinatesAtom";
